import React from "react";
import { useNavigate } from 'react-router-dom';
import '../css/common.css'

import imageOne from '../resource/events/F4.png'
import imageOtwo from '../resource/events/F4 (2).png'
import imageThree from '../resource/events/F5.png'

import imageFive from '../resource/events/L6 (2).png'
import imageSix from '../resource/events/7.png'
import imageSeven from '../resource/events/L8 (2).png'
import imageEight from '../resource/events/L9 (2).png'
import imageNine from '../resource/events/F6.png'
import imageTen from '../resource/events/10.png'

import TitleChnage from "../Hook/TitleChnage";


const Event = () => {

    const navigate = useNavigate();

    TitleChnage("Events Page");

    const handleClick = (event) => {

        const pathMap = {
            demonstration : '/demonstration',
            eventNotification : '/eventNotification',
            eventcalendar:'/eventcalendar',
            annualceremonies:'/annualceremonies'
        }
    
        const path = event.currentTarget.id;
        const targetPath = pathMap[path]
    
        if (targetPath){
          navigate(targetPath)
        }
      }

    return(
        <div className="page event-page">
        <img src={imageOne} alt="" className="left-imge" />
        <img src={imageOtwo} alt="" className="right-imge" />



        <header>
            <div className="home-icon">
                {/* <img src="#" alt="Home Icon"> */}
            </div>
            <div className="title">
                <h1>Events</h1>
                <img src={imageThree} width={200} />
            </div>
        </header>

        <div className="poem2">
                <div className="text-left">
                    <p>Let us gather as one at home,</p>
                    <p>To share the joy through moral virtues</p>
                    <p>With meritorious deeds on auspicious days,</p>
                    <p>We gain and share abundant happiness</p>
                    <p>Spreading goodness and merits</p>
                    <p>Like the blossoming beauty of spring</p>
                </div>
                
            </div>

        <section className="button-section">
            <div className="left-col">
            <img src={imageTen} alt="" width={250}  id="eventcalendar" onClick={handleClick}/>
            <img src={imageFive} alt="" width={250} id="eventNotification" onClick={handleClick}/>
                
            </div>
  
            <div className="right-col">
                
                <img src={imageSeven} alt="" width={250} id="annualceremonies" onClick={handleClick}/>
                <img src={imageSix} alt="" width={250} id="demonstration" onClick={handleClick}/>

            </div>
        </section>

        <div className="box">
            <img src={imageNine} alt="" className="bottom-imge" />
        </div>
    </div>
    )
}


export default Event